<template>
    <ItemCard :item="material" :imageUrl="imageUrl" :isBookmarked="true" :showBookMark="!isUnitPlan" bookmarkRoute="tm.bookmark" :actionUrl="url" @click="notifyAlgoliaAboutClick()" >
        <template v-slot:badge>
            <div
                class="overflow-hidden flex-shrink-0 bottom-0 left-0 pr-2  pl-1 -ml-1 -mb-1  absolute bg-white flex items-center justify-center rounded-tr-xl rounded-bl-xl text-sm z-10 ">
                <span v-if="material.is_internal_unit_plan">Unit Plan</span>
                <span v-else>{{ material.type }}</span>
            </div>
        </template>
        <template v-slot:image>
            <div class="w-full h-full resource-card duration-150 object-cover overflow-hidden rounded-bl-[13px] rounded-tr-xl rounded-tl-xl rounded-br-xl">
                <img class="w-full h-full object-cover group-hover:scale-105 duration-150  " :src="imageUrl" alt="Avatar"/>
            </div>
        </template>
        <template v-slot:bands>
           <Grades :grades="material.grades" />
        </template>
        <template v-slot:title>
            <a :href="url">
                <AisHighlight v-if="isLoadedFromAlgolia" attribute="title" :hit="material" :class-names="{'ais-Highlight': 'font-semibold line-clamp-3'}" />
                <h3 v-else class="line-clamp-3 mt-[12px] font-semibold">{{ material.title }}</h3>

            </a>
        </template>

        <template v-slot:tags >
            <span v-for="subject in material.subjects_list_short" :key="subject" class="text-xs rounded-2xl bg-[#EEF1F6] px-2.5 py-0.5">{{ subject }}</span>
        </template>

    </ItemCard>
</template>

<script>
import { inject } from 'vue';
import ItemCard from '../../../components/ItemCard.vue'
import { AisHighlight } from 'vue-instantsearch/vue3/es';
import { usePage } from '@inertiajs/vue3';
import {sortGradeBands} from '../../../Helpers/Utils.js'
import Grades from '../../../components/Grades.vue'
import { trackClick } from '../../../Helpers/MeilisearchAnalytics.js'
export default {
    components: {
        ItemCard,
        AisHighlight,
        Grades
    },
    props: {
        fromUnitPlanPage: {
            type: Boolean,
            default: false,
        },
        isUnitPlan: {
            type: Boolean,
            default: false,
        },
        isLoadedFromAlgolia: {
            default : true,
            type: Boolean
        },
        isActivity: {
            type: Boolean,
            default: false,
        },
        material: Object,
        index: {
            type: Number,
            default: 0,
        },
        position: {
            type: Number,
            default: null
        },
        queryUid: {
            type: String,
            default: null
        },
        buttonTextColor:{
            type : String,
            default : null
        },
        ctaColor: {
            type : String,
            default : null
        }
    },
    computed: {
        url() {
            if (!this.material.slug)
                return '#';
            let url;
            if (this.material.is_internal_resource)
                url = route('stc.show', this.material.slug);
            else if (this.material.is_internal_unit_plan)
                url = route('stc.unit', this.material.slug);

            // Add queryUid to URL for conversion tracking
            if (url && this.queryUid) {
                const separator = url.includes('?') ? '&' : '?';
                return url + separator + 'queryUid=' + encodeURIComponent(this.queryUid);
            }
            return url;
        },
        providerImageUrl() {
            return this.material.firstProviderCircleImageUrl ?? this.material.firstProviderImageUrl;
        },
        imageUrl() {
            if (this.material.image_conversions && this.material.image_conversions['240'])
                return this.material.image_conversions['240'];

            if (this.material.image_conversions && this.material.image_conversions['360'])
                return this.material.image_conversions['360'];
            return this.material.image;
        }
    },
    methods: {
        notifyAlgoliaAboutClick() {
            // Track click event for Meilisearch analytics
            const indexUid = this.teachingMaterialsIndex || 'teaching_materials';
            trackClick({
                indexUid: indexUid,
                objectId: String(this.material.id),
                objectName: this.material.title,
                position: this.position,
                queryUid: this.queryUid
            });

            // Legacy Algolia tracking (if still needed)
            if (this.aa) {
                let materialId = this.material.id;
                this.aa('clickedObjectIDs', {
                    objectIDs: [materialId.toString()],
                    eventName: 'Internal Resource Clicked',
                    index: this.teachingMaterialsIndex
                });
            }
        },
        sortGradeBands
    },
    mounted() {
        console.log('iruetghriutghirutgh');
    },
    setup() {
        const aa = inject('initAndGetAlgoliaEventDispatcher')()
        const page = usePage();
        const teachingMaterialsIndex = page.props.integrations?.meilisearch?.teachingMaterialsIndex ||
                                      page.props.integrations?.algolia?.teachingMaterialsIndex ||
                                      'teaching_materials';
        return {
            aa,
            teachingMaterialsIndex
        }
    }
}
</script>
